export default function ButtonSection({ children }: React.PropsWithChildren) {
  return (
    <section>
      <div className="inner">
        <div className="buttons">{children}</div>
      </div>
    </section>
  );
}
